import { Box } from '@mui/joy'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/common/viewer'
import { Button } from '~/shared/ui/Buttons'
import { Modal, useModal } from '~/shared/ui/Modal'
import { Form, FormValues } from './Form'
import { syncBalanceFx } from './model'

export function SyncBalanceModal() {
  const { t } = useTranslation()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const { isModalShow, closeModal, openModal } = useModal()
  const { canSyncBalanceTasks } = usePermissions()

  const handleOnOk = useCallback(
    async ({ aggregatorProfileId, fromDate, toDate }: FormValues) => {
      try {
        setIsSubmitting(true)
        await syncBalanceFx({
          aggregatorProfileId,
          fromDate,
          toDate,
        })
        closeModal()
      } finally {
        setIsSubmitting(false)
      }
    },
    [closeModal],
  )

  if (!canSyncBalanceTasks) return null

  return (
    <>
      <Button variant='yellow' onClick={openModal}>
        {t('button.sync balance')}
      </Button>
      <Modal
        isShow={isModalShow}
        onCancel={closeModal}
        title={t('sync balance')}
        dialogProps={{
          sx: {
            minWidth: '600px',
            maxWidth: '600px',
            overflow: 'visible',
          },
        }}
      >
        <Box sx={{ padding: '4px' }}>
          <Form
            onSuccess={handleOnOk}
            onCancel={closeModal}
            isSubmitting={isSubmitting}
          />
        </Box>
      </Modal>
    </>
  )
}
